
import React, { useEffect, useState } from "react";
import { Api } from "../Api/Api";

const OriginalAmountPage = () => {
  const [code, setCode] = useState("");
  const [customer, setCustomer] = useState(null);
  const [payAmount, setPayAmount] = useState("");
  const [payDate, setPayDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [remaining, setRemaining] = useState(null);
  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState([]);
  const [historySearch, setHistorySearch] = useState("");
  


  // For Search Results Dropdown
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    loadAllPayments();
  }, []);

  const loadAllPayments = async () => {
    const res = await fetch(`${Api}payments/list-original-payments.php`);
    const data = await res.json();
    setPayments(data.payments || []);
  };

  // ✅ IMPROVED SEARCH: Handle Code or Name
  const handleSearch = async (val) => {
    setCode(val);
    if (val.length < 2) {
      setSearchResults([]);
      setShowDropdown(false);
      return;
    }

    // You can replace this with a specific search API if available
    // For now, we fetch potential matches
    const res = await fetch(`${Api}customers/search.php?query=${val}`);
    const data = await res.json();

    if (data.status && data.customers) {
      setSearchResults(data.customers);
      setShowDropdown(true);
    }
  };

  const selectCustomer = (cust) => {
    setCustomer(cust);
    setRemaining(cust.investment_amount);
    setCode(cust.customer_code); // Show code in input
    setShowDropdown(false);
  };

  const handleAmountChange = (value) => {
    setPayAmount(value);
    if (!customer) return;
    const balance = Number(customer.investment_amount) - Number(value || 0);
    setRemaining(balance < 0 ? 0 : balance);
  };

  const savePayment = async () => {
    if (!customer) return alert("Search and select a customer first");
    if (!payAmount || payAmount <= 0) return alert("Enter valid amount");

    setLoading(true);
    const res = await fetch(`${Api}payments/original-payment.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customer_id: customer.id,
        amount: payAmount,
        date: payDate,
      }),
    });

    const data = await res.json();
    setLoading(false);

    if (data.status) {
      alert("Payment recorded successfully");
      setPayAmount("");
      setCustomer(null);
      setCode("");
      loadAllPayments();
    } else {
      alert(data.message);
    }
  };



  const filteredPayments = payments.filter(
  (p) =>
    p.name?.toLowerCase().includes(historySearch.toLowerCase()) ||
    p.customer_code?.toLowerCase().includes(historySearch.toLowerCase())
);



const formatDDMMYYYY = (dateStr) => {
  if (!dateStr) return "-";

  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();

  return `${dd}-${mm}-${yyyy}`;
};


  return (
    <div className="max-w-6xl mx-auto p-4 md:p-6 space-y-6">
      {/* 🔼 PAYMENT ENTRY SECTION */}
      <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border">
        <h2 className="text-xl font-extrabold mb-4 text-gray-800">
          Prinicipal Amount Payment
        </h2>

        {/* SEARCH BOX */}
        <div className="relative mb-4">
          <div className="flex flex-col sm:flex-row gap-2">
            <input
              value={code}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder="Search Name or Customer Code..."
              className="border border-gray-300 p-2.5 rounded-lg w-full focus:ring-2 focus:ring-indigo-500 outline-none"
            />
            {!customer && (
              <div className="hidden sm:block px-4 py-2 text-xs text-gray-400 italic">
                Type to search...
              </div>
            )}
          </div>

          {/* Search Results Dropdown */}
          {showDropdown && searchResults.length > 0 && (
            <div className="absolute z-10 w-full bg-white border rounded-lg shadow-lg mt-1 max-h-60 overflow-y-auto">
              {searchResults.map((cust) => (
                <div
                  key={cust.id}
                  onClick={() => selectCustomer(cust)}
                  className="p-3 hover:bg-indigo-50 cursor-pointer border-b last:border-none flex justify-between items-center"
                >
                  <div>
                    <p className="font-bold text-gray-800">{cust.name}</p>
                    <p className="text-xs text-gray-500">
                      {cust.customer_code}
                    </p>
                  </div>
                  <p className="text-sm font-semibold text-indigo-600">
                    ₹{cust.investment_amount}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* PAYMENT FORM (Visible only when customer selected) */}
        {customer && (
          <div className="space-y-4 animate-in fade-in duration-300">
            <div className="text-sm bg-indigo-50 p-4 rounded-lg border border-indigo-100 flex flex-col md:flex-row md:justify-between md:items-center gap-2">
              <div>
                <p className="text-gray-600">Selected Customer</p>
                <p className="text-lg font-bold text-gray-900">
                  {customer.name} ({customer.customer_code})
                </p>
              </div>
              <div className="text-right">
                <p className="text-gray-600">Current Investment</p>
                <p className="text-lg font-bold text-indigo-700">
                  ₹{customer.investment_amount}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
              <div className="flex flex-col gap-1">
                <label className="text-xs font-bold text-gray-500 uppercase">
                  Payment Date
                </label>
                <input
                  type="date"
                  value={payDate}
                  onChange={(e) => setPayDate(e.target.value)}
                  className="border border-gray-300 p-2.5 rounded-lg w-full"
                />
              </div>

              <div className="flex flex-col gap-1">
                <label className="text-xs font-bold text-gray-500 uppercase">
                  Amount to Pay (₹)
                </label>
                <input
                  type="number"
                  placeholder="0.00"
                  value={payAmount}
                  onChange={(e) => handleAmountChange(e.target.value)}
                  className="border border-gray-300 p-2.5 rounded-lg w-full font-bold"
                />
              </div>

              <div className="bg-green-50 p-2.5 rounded-lg border border-green-100">
                <p className="text-xs text-green-600 font-bold uppercase">
                  Projected Balance
                </p>
                <p className="text-xl font-black text-green-700">
                  ₹{remaining?.toLocaleString()}
                </p>
              </div>
            </div>

            <div className="flex gap-2">
              <button
                onClick={savePayment}
                disabled={loading}
                className="flex-1 bg-green-600 hover:bg-green-700 text-white font-bold py-3 rounded-lg transition-colors shadow-md disabled:bg-gray-400"
              >
                {loading ? "Processing..." : "Confirm & Save Payment"}
              </button>
              <button
                onClick={() => setCustomer(null)}
                className="px-4 py-3 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200"
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>

      {/* 🔽 PAYMENT HISTORY TABLE */}
      <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-2">
          <h3 className="text-lg font-extrabold text-gray-800">
            Prinicipal Payment History
          </h3>
          <span className="text-xs font-semibold bg-gray-100 text-gray-500 px-3 py-1 rounded-full w-fit">
            Total Records: {payments.length}
          </span>
        </div>


        <div className="mb-3 flex items-center justify-between gap-2">
  <input
    type="text"
    placeholder="Search by Name or Customer Code..."
    value={historySearch}
    onChange={(e) => setHistorySearch(e.target.value)}
    className="w-full max-w-md px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 outline-none"
  />
  <span className="text-xs text-gray-500 font-semibold">
    {filteredPayments.length} results
  </span>
</div>


        <div className="overflow-x-auto rounded-lg border border-gray-100">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600 font-bold border-b">
              <tr>
                <th className="p-3 text-center">S.No</th>
                <th className="p-3 text-left">Customer Code</th>
                <th className="p-3 text-left">Name</th>
                <th className="p-3 text-left">Date</th>
                <th className="p-3 text-right">Paid Amount</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {payments.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center p-8 text-gray-400">
                    No payment history available.
                  </td>
                </tr>
              ) : (
                filteredPayments.map((p, i) => (
                  <tr key={p.id} className="hover:bg-gray-50 transition-colors">
                    <td className="p-3 text-center text-gray-400">{i + 1}</td>
                    <td className="p-3 font-mono font-bold text-gray-700 whitespace-nowrap">
                      {p.customer_code}
                    </td>
                    <td className="p-3 text-gray-800 font-medium whitespace-nowrap">
                      {p.name}
                    </td>
                    {/* <td className="p-3 text-gray-600 whitespace-nowrap">
                      {p.pay_date}
                    </td> */}

                    <td className="p-3 text-gray-600 whitespace-nowrap">
  {formatDDMMYYYY(p.pay_date)}
</td>

                    <td className="p-3 text-right font-black text-green-700 whitespace-nowrap">
                      ₹{Number(p.amount).toLocaleString()}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OriginalAmountPage;